import LazyLoaderFactory from './lazyLoader';

function Trumbowyg(props) {
    return (
        <LazyLoaderFactory module={import(/* webpackChunkName: "trumbowyg" */ '../theme/trumbowyg')}
                           props={props}/>
    );
}

export default Trumbowyg;
